import { Version } from '@repo/toolkit/types'
import { PaginationRequest } from '@repo/ui/data-table'

import {
  CenterTripBookingFilter,
  TripBookingTypes
} from '../../lib/types/models/trip-booking/trip-booking'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type SortingType = {
  [K in keyof TripBookingTypes.View]?: 'asc' | 'desc' | { id: 'asc' | 'desc' }
}

export function getCenterTripBookings(
  id: number,
  input: PaginationRequest<CenterTripBookingFilter, Version, Version, SortingType> = {}
) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.centers.getCenterTripBookings.url, { id }),
        input
      )
    )
    .get<TripBookingTypes.View[]>()
}
